// document.addEventListener('rebuy:cart.change', function(event) {
//   console.log('cart change');
//   // const cart = event.detail.cart;
//   // const checkoutButton = document.querySelector('.rebuy-cart__checkout-button');

//   // if (checkoutButton && cart && cart.total_price) {
//   //   const subtotal = (cart.total_price / 100).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
//   //   checkoutButton.textContent = `proceder al pago • ${subtotal}`;
//   // }
// })

// document.addEventListener('rebuy:cart.change', function(event) {
//   const cart = event.detail.cart;
//   const checkoutButton = document.querySelector('.rebuy-cart__checkout-button span');

//   if (checkoutButton && cart && cart.total_price) {
//     const subtotal = (cart.total_price / 100).toLocaleString('es-MX', {
//       style: 'currency',
//       currency: 'MXN'
//     });
//     checkoutButton.innerHTML = `Finalizar compra • ${subtotal}`;
//   }
//   console.log('cart change');
// });

// (function() {
//   function updateCheckoutLabel(cart) {
//     if (!cart || !cart.total_price) return;

//     const subtotal = (cart.total_price / 100).toLocaleString('es-MX', {
//       style: 'currency',
//       currency: 'MXN'
//     });

//     const interval = setInterval(() => {
//       const checkoutSpan = document.querySelector('.rebuy-cart__checkout-button span');
//       if (checkoutSpan) {
//         clearInterval(interval);
//         checkoutSpan.innerHTML = `Finalizar compra • ${subtotal}`;
//         console.log('✅ Label actualizado:', subtotal);
//       }
//     }, 300);
//   }

//   // Escucha todos los eventos relevantes de Rebuy
//   ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:modal.show', 'rebuy:drawer.show'].forEach(evt => {
//     document.addEventListener(evt, e => {
//       console.log(`📦 Evento ${evt} detectado`);
//       updateCheckoutLabel(e.detail.cart);
//     });
//   });
// })();

(function() {
  function updateCheckoutLabel(cart) {
    if (!cart || !cart.total_price || !window.SmartCart) return;

    const subtotal = (cart.total_price / 100).toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN'
    });

    // SVG embebido (candado)
    const lockSVG = `
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" style="margin-right:6px;vertical-align:middle;">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m6 0a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M8 9V7a4 4 0 1 1 8 0v2" />
      </svg>
    `;

    // Usando el método oficial de Rebuy
    SmartCart.checkoutLabel = ` Finalizar compra • `;
    console.log('✅ Label actualizado con ícono y subtotal usando SmartCart.checkoutLabel:');
  }

  // Escucha los eventos de Rebuy
  ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:modal.show', 'rebuy:drawer.show'].forEach(evt => {
    document.addEventListener(evt, e => updateCheckoutLabel(e.detail.cart));
  });
})();
